import React, { Component } from "react";
import { callPlayer, getSDK, parseStartTime } from "../utils.js";
const SDK_URL = "https://api.dmcdn.net/all.js";
const SDK_GLOBAL = "DM";
const SDK_GLOBAL_READY = "dmAsyncInit";
const MATCH_URL = /^(?:(?:https?):)?(?:\/\/)?(?:www\.)?(?:(?:dailymotion\.com(?:\/embed)?\/video)|dai\.ly)\/([a-zA-Z0-9]+)(?:_[\w_-]+)?$/;
class DailyMotion extends Component {
  constructor() {
    super(...arguments);
    this.callPlayer = callPlayer;
    this.onDurationChange = () => {
      const duration = this.getDuration();
      this.props.onDuration(duration);
    };
    this.mute = () => {
      this.callPlayer("setMuted", true);
    };
    this.unmute = () => {
      this.callPlayer("setMuted", false);
    };
    this.ref = (container) => {
      this.container = container;
    };
  }
  load(url) {
    const { controls, config, onError, playing } = this.props;
    const [, id] = url.match(MATCH_URL);
    if (this.player) {
      this.player.load(id, {
        start: parseStartTime(url),
        autoplay: playing
      });
      return;
    }
    getSDK(
      SDK_URL,
      SDK_GLOBAL,
      SDK_GLOBAL_READY,
      (DM) => DM.player
    ).then((DM) => {
      if (!this.container) {
        return;
      }
      const Player = DM.player;
      this.player = new Player(this.container, {
        width: "100%",
        height: "100%",
        video: id,
        params: {
          controls,
          autoplay: this.props.playing,
          mute: this.props.muted,
          start: parseStartTime(url),
          origin: window.location.origin,
          ...config.dailymotion.params
        },
        events: {
          apiready: this.props.onReady,
          seeked: () => this.props.onSeek(this.player.currentTime),
          video_end: this.props.onEnded,
          durationchange: this.onDurationChange,
          pause: this.props.onPause,
          playing: this.props.onPlay,
          waiting: this.props.onBuffer,
          error: (event) => onError(event)
        }
      });
    }, onError);
  }
  play() {
    this.callPlayer("play");
  }
  pause() {
    this.callPlayer("pause");
  }
  stop() {
  }
  seekTo(seconds) {
    this.callPlayer("seek", seconds);
  }
  setVolume(fraction) {
    this.callPlayer("setVolume", fraction);
  }
  getDuration() {
    return this.player.duration || null;
  }
  getCurrentTime() {
    return this.player.currentTime;
  }
  getSecondsLoaded() {
    return this.player.bufferedTime;
  }
  render() {
    const { display } = this.props;
    const style = {
      width: "100%",
      height: "100%",
      display
    };
    return /* @__PURE__ */ React.createElement("div", { style }, /* @__PURE__ */ React.createElement("div", { ref: this.ref }));
  }
}
DailyMotion.displayName = "DailyMotion";
DailyMotion.canPlay = (url) => MATCH_URL.test(url);
DailyMotion.loopOnEnded = true;
export {
  DailyMotion
};
//# sourceMappingURL=dailymotion.js.map
